/**
 * CRC-16/CCITT-FALSE, as required by the EMVCo QR spec (tag 63).
 *
 * Byte-for-byte port of `apps/backend/src/modules/vietqr/crc16.util.ts`;
 * `vietqr.test.ts` asserts both stay in agreement via shared fixtures.
 */
export function crc16ccitt(input: string): string {
  let crc = 0xffff;
  for (let i = 0; i < input.length; i++) {
    crc ^= input.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      crc = crc & 0x8000 ? (crc << 1) ^ 0x1021 : crc << 1;
      crc &= 0xffff;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, '0');
}
